// extracted by mini-css-extract-plugin
export default {"root":"styles_root__c1fxM","actasuser":"styles_actasuser__k8zlc"};